// Обработчик событий, связанных с auth
// Здесь подписываемся на ответы auth_success / auth_error
import emitter from "../../core/wsEmitter";
import { store } from "../../../store/store";
import {
	setIsSocketLoaded,
	setSocketStatus,
} from "../../../store/slices/app.slice";
import { setSessionId } from "../../../store/slices/session.slice";
import { setSessionDataInState } from "../session/session.service";

// auth_success — server -> client
// auth_error — server -> client

emitter.on("auth_success", (data: any) => {
	store.dispatch(setSocketStatus("online"));
	store.dispatch(setIsSocketLoaded(true));

	// Если в ответе есть данные сессии — сохраняем их (auth с session_id)
	if (data.session_id && data.messages !== undefined) {
		setSessionDataInState({
			count: data.count,
			messages: data.messages,
			ok: data.ok,
			previous_session_id: data.previous_session_id ?? null,
			session_id: data.session_id,
			type: data.type,
		});
		store.dispatch(setSessionId(data.session_id));
	}
});

emitter.on("auth_error", (data: any) => {
	store.dispatch(setSocketStatus("auth-error"));
});
